import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "hooks/useAuthContext";

export const MobileOrganizationInfoSection = (props: {
    organizationName: string,
    userRole: string,
    patronNames: string[],
    tagA: string,
    tagB: string
}) => {
    const { userState } = useAuthContext();
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box width="100%" padding={theme.spacing(1)}>
            <Typography variant="h6">{t("profile.yourPlaceInOrganization")}</Typography>
            <Stack marginTop={2} spacing={2}>
                <Stack spacing={0.5}>
                    <Typography variant="caption" color="text.secondary">{t("general.organization")}</Typography>
                    <Typography variant="subtitle1" fontWeight={500}>
                        {props.organizationName ?? userState.user.selectedWorkspace.workspaceName}
                    </Typography>
                </Stack>
                <Stack spacing={0.5}>
                    <Typography variant="caption" color="text.secondary">{t("general.role")}</Typography>
                    <Typography variant="subtitle1" fontWeight={500}>
                        {t(`roles.${props.userRole}`)}
                    </Typography>
                </Stack>
                <Stack spacing={0.5}>
                    <Typography variant="caption" color="text.secondary">{t("general.patron")}</Typography>
                    {props.patronNames.length > 0
                        ? props.patronNames.map((name, index) => (
                            <Typography key={index} variant="subtitle1" fontWeight={500}>{name}</Typography>
                        ))
                        : <Typography variant="subtitle1" fontWeight={500}>{t("general.none")}</Typography>
                    }
                </Stack>
                {props.tagA && (
                    <Stack spacing={0.5}>
                        <Typography variant="caption" color="text.secondary">{t("general.tagA")}</Typography>
                        <Typography variant="subtitle1" fontWeight={500}>{props.tagA}</Typography>
                    </Stack>
                )}
                {props.tagB && (
                    <Stack spacing={0.5}>
                        <Typography variant="caption" color="text.secondary">{t("general.tagB")}</Typography>
                        <Typography variant="subtitle1" fontWeight={500}>{props.tagB}</Typography>
                    </Stack>
                )}
            </Stack>
        </Box>
    );
};
